import { createAsyncThunk as y, createSlice as E } from "@reduxjs/toolkit";
import { HTTPVerbs as u, Logger as n, request as l, StorageService as w } from "@nextgen-web-framework/core";
var b = /* @__PURE__ */ ((a) => (a.DETAILED = "DETAILED", a.ALL = "ALL", a.MIN = "MIN", a))(b || {});
const d = "{VersionId}", P = "{ShopId}", A = {
  url: `/commyshopas/${d}/myshops`,
  method: u.GET,
  retries: 0
}, D = {
  url: `/commyshopas/${d}/myshops`,
  method: u.POST,
  retries: 0
}, $ = {
  url: `/commyshopas/${d}/myshops/${P}`,
  method: u.PUT,
  retries: 0
}, v = {
  url: `/commyshopas/${d}/myshopimages`,
  method: u.POST,
  retries: 0
};
function c(a, e) {
  return {
    component: a,
    page: e,
    product: "commerce-myshop-webcomponents"
  };
}
const i = {
  async getMyShop({ projections: a = b.ALL, shopCodeUrl: e = void 0 }, t) {
    const r = n.getInstance(c("myshopApi.getMyShop"));
    try {
      const o = { ...A };
      o.url = o.url.replace(d, "v1"), o.params = {
        projections: a
      }, e && e !== "" && (o.params = { shopCode: e, ...o.params }), t != null && t.headers && (o.headers = t == null ? void 0 : t.headers), t != null && t.baseURL && (o.url = `${t.baseURL}${o.url}`);
      const s = await l(o);
      if (Object.keys(s).includes("myshops")) {
        const p = s, { myshops: h } = p;
        if (Array.isArray(h) && h.length > 0)
          return h[0];
      }
      return s;
    } catch (o) {
      throw r.error("myshopApi.getMyShop", o), o;
    }
  },
  async createMyShop({ payload: a }, e) {
    const t = n.getInstance(c("myshopApi.createMyShop"));
    try {
      const r = { ...D };
      r.url = r.url.replace(d, "v1");
      const o = await m(a);
      return r.body = o, e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`), await l(r);
    } catch (r) {
      throw t.error("myshopApi.createMyShop", r), r;
    }
  },
  async updateMyShop({ payload: a }, e) {
    const t = n.getInstance(c("myshopApi.updateMyShop"));
    try {
      const r = { ...$ }, o = w.getLocalStorage().retrieve("ShopId"), s = await m(a, o);
      return r.url = r.url.replace(d, "v1"), r.url = r.url.replace(P, o), r.body = s, e != null && e.headers && (r.headers = e == null ? void 0 : e.headers), e != null && e.baseURL && (r.url = `${e.baseURL}${r.url}`), await l(r);
    } catch (r) {
      throw t.error("myshopApi.updateMyShop", r), r;
    }
  },
  async uploadMyShopImage({ payload: a }, e, t) {
    const r = n.getInstance(c("myshopApi.uploadMyShopImage"));
    try {
      const o = { ...v };
      return o.url = o.url.replace(d, "v1"), o.body = a, t != null && t.headers && (o.headers = t == null ? void 0 : t.headers), t != null && t.baseURL && (o.url = `${t.baseURL}${o.url}`), e && e !== "" && (o.params = { inputShopId: e }), await l(o, {
        skipDefaultContentType: !0
      });
    } catch (o) {
      throw r.error("myshopApi.uploadMyShopImage", o), o;
    }
  }
};
async function m(a, e) {
  const t = n.getInstance(c("myshopApi.processPayloadBody"));
  try {
    const r = a, o = g(r, "profileImageData", "profile"), s = g(r, "bannerImageData", "banner"), p = [];
    return S(p, o, e), S(p, s, e), p.length > 0 && await j(p, r), r;
  } catch (r) {
    throw t.error("myshopApi.processPayloadBody", r), r;
  }
}
function S(a, e, t) {
  e && e.get("imageData") && a.push(i.uploadMyShopImage({ payload: e }, t));
}
async function j(a, e) {
  const t = n.getInstance(c("myshopApi.processUploadPromises"));
  try {
    const r = await Promise.allSettled(a);
    if (r.some((o) => o.status === "rejected"))
      throw new Error("error on upload image");
    r.forEach((o) => {
      if (o.status === "fulfilled") {
        const s = o.value;
        U(s, e);
      }
    });
  } catch (r) {
    throw t.error("myshopApi.processUploadPromises", r), r;
  }
}
function U(a, e) {
  var t, r;
  if (Object.keys(a).includes("bannerId")) {
    const o = a;
    (t = o.bannerId) != null && t.includes("banner") && (e.bannerImageData = void 0, e.bannerInfo = a), (r = o.bannerId) != null && r.includes("profile") && (e.profileImageData = void 0, e.profilePicture = {
      imageId: o.bannerId,
      imageUrl: o.bannerUrl,
      mime: o.mime
    });
  }
  Object.keys(a).includes("imageId") && (e.profileImageData = void 0, e.profilePicture = a);
}
function g(a, e, t) {
  let r = new FormData();
  if (["bannerImageData", "profileImageData"].includes(e) && a[e]) {
    const o = new FormData(), s = a[e], p = new Blob([s], { type: "image/jpeg" });
    return o.append("imageData", p, e === "bannerImageData" ? "banner.jpg" : "profile.jpg"), o.append("imageType", t), r = o, r;
  }
  return r;
}
const f = {
  isLoading: !1,
  hasError: !1,
  error: {},
  selectedBannerImage: "",
  selectedProfileImage: "",
  updatedBannerImage: "",
  updatedProfileImage: "",
  selectedTnc: !1,
  shop: {},
  getMyShopStatusError: !1,
  createMyShopStatusSuccess: !1,
  createMyShopStatusError: !1,
  updateMyShopStatusSuccess: !1,
  updateMyShopStatusError: !1,
  updateFeatureProductSuccess: !1,
  hasLoaded: !1
}, I = y(
  "commerceMyshop/getMyShop",
  async ({ projections: a, shopCodeUrl: e }) => await i.getMyShop({
    projections: a,
    shopCodeUrl: e
  })
), M = y(
  "commerceMyshop/createMyShop",
  ({ payload: a }) => i.createMyShop({
    payload: a
  })
), L = y(
  "commerceMyshop/updateMyShop",
  ({ payload: a }) => i.updateMyShop({
    payload: a
  })
);
function T(a) {
  return a.type.endsWith("/pending");
}
function C(a) {
  return a.type.endsWith("/fulfilled");
}
function B(a) {
  return a.type.startsWith("commerceMyShop") && a.type.endsWith("/rejected");
}
const R = E({
  name: "commerceMyshop",
  initialState: f,
  reducers: {
    resetMyshopSlice: () => f,
    updateSelectedBanner: (a, e) => {
      a.selectedBannerImage = e.payload, a.updatedBannerImage = e.payload;
    },
    updateSelectedProfile: (a, e) => {
      a.selectedProfileImage = e.payload, a.updatedProfileImage = e.payload;
    },
    resetProfileBannerImage: (a) => {
      a.updatedBannerImage = "", a.updatedProfileImage = "";
    },
    updateSelectedTnc: (a, e) => {
      a.selectedTnc = e.payload;
    },
    updateMyListCreateState: (a) => {
      a.updateMyShopStatusError = !1, a.updateMyShopStatusSuccess = !1, a.updateFeatureProductSuccess = !1;
    }
  },
  extraReducers: (a) => {
    a.addCase(I.fulfilled, (e, t) => {
      e.isLoading = !1, e.hasError = !1, e.shop = t.payload, e.hasLoaded = !0;
    }), a.addCase(I.rejected, (e, t) => {
      e.isLoading = !1, e.hasError = !0, e.error = t, e.getMyShopStatusError = !0, e.hasLoaded = !0;
    }), a.addCase(M.fulfilled, (e, t) => {
      e.isLoading = !1, e.hasError = !1, e.shop = t.payload, e.createMyShopStatusSuccess = !0;
    }), a.addCase(M.rejected, (e, t) => {
      e.isLoading = !1, e.hasError = !1, e.error = t, e.createMyShopStatusError = !0;
    }), a.addCase(L.fulfilled, (e, t) => {
      e.isLoading = !1, e.hasError = !1;
      const r = e.shop, o = t.payload;
      o.featureProducts && (r.featureProducts === void 0 || JSON.stringify(r.featureProducts) !== JSON.stringify(o.featureProducts)) ? e.updateFeatureProductSuccess = !0 : e.updateMyShopStatusSuccess = !0, e.shop = t.payload;
    }), a.addCase(L.rejected, (e, t) => {
      e.isLoading = !1, e.hasError = !0, e.error = t, e.updateMyShopStatusError = !0;
    }), a.addMatcher(B, (e, t) => {
      e.isLoading = !1, e.hasError = !0, e.error = t;
    }), a.addMatcher(C, (e) => {
      e.isLoading = !1, e.hasError = !1;
    }), a.addMatcher(T, (e) => {
      e.isLoading = !0, e.hasError = !1;
    });
  }
}), {
  resetMyshopSlice: F,
  updateSelectedBanner: N,
  updateSelectedProfile: W,
  updateSelectedTnc: x,
  updateMyListCreateState: J,
  resetProfileBannerImage: V
} = R.actions;
export {
  b as D,
  W as E,
  V as I,
  J as L,
  x as P,
  i as j,
  L as l,
  N as m,
  I as p
};
//# sourceMappingURL=myshopSlice-9fa3f40a.mjs.map
